module.exports = __webpack_public_path__ + "static/media/ic_exception.29a98b1e.png";